import * as types from '../actions/types';
import { path } from 'ramda';

const INITIAL = {
  data: null,
  participationItemsData: null,
  userParticipationItems: null,
  participationItemList: null,
  needToPurchaseItems: null,
  needToPurchaseItemsPrice: null,
  userOwnedParticipationItems: null,
  participationDetail: null,
  appliedItems: null,
  isError: false
};

const userParticipationItemsReducer = (state = INITIAL, action) => {
  switch (action.type) {
    case types.USER_PARTICIPATION_ITEMS_REQUESTED:
      return {
        ...state,
        error: null
      };
    case types.USER_PARTICIPATION_ITEMS_SUCCEEDED:
      return {
        ...state,
        participationItemsData: path(
          ['data', 'data', 'participationItems'],
          action
        ),
        userParticipationItems: path(['data', 'data', 'userItems'], action),
        participationItemList: path(['data', 'data', 'itemList'], action),
        needToPurchaseItems: path(['data', 'data', 'purchaseItems'], action),
        needToPurchaseItemsPrice: path(['data', 'data', 'totalPrice'], action),
        participationDetail: path(['data', 'data', 'participationDetail'], action),
        appliedItems: path(['data', 'data', 'appliedItems'], action),
        data: action.data.data,
        error: null
      };
    case types.USER_PARTICIPATION_ITEMS_FAILED:
      return {
        ...state,
        data: null,
        isError: true,
        error: action.error
      };
    case types.UPDATE_USER_PARTICIPATION_ITEMS_REQUESTED:
      return {
        ...state,
        error: null
      };
    case types.UPDATE_USER_PARTICIPATION_ITEMS_FAILED:
      return {
        ...state,
        isError: true,
        error: action.error
      };
    case types.USER_OWNED_PARTICIPATION_ITEMS_REQUESTED:
      return {
        ...state,
        error: null
      };
    case types.USER_OWNED_PARTICIPATION_ITEMS_SUCCEEDED:
      return {
        ...state,
        userOwnedParticipationItems: action.data.data,
        error: null
      };
    case types.USER_OWNED_PARTICIPATION_ITEMS_FAILED:
      return {
        ...state,
        data: null,
        isError: true,
        error: action.error
      };
    default:
      return state;
  }
};

export default userParticipationItemsReducer;
